import { CountryWithStateAndCityOutputStateData } from './country-with-state-and-city-output-state-data.model';


export class CountryWithStateAndCityOutputData implements ICountryWithStateAndCityOutputData {
    /** The auto-generated id of the country master */
    country_id!: number;
    /** The country name with 255 character limit */
    country_name!: string;
    state!: CountryWithStateAndCityOutputStateData[];

    constructor(data?: ICountryWithStateAndCityOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country_id = _data["country_id"];
            this.country_name = _data["country_name"];
            if (Array.isArray(_data["state"])) {
                this.state = [] as any;
                for (let item of _data["state"])
                    this.state!.push(CountryWithStateAndCityOutputStateData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryWithStateAndCityOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new CountryWithStateAndCityOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country_id"] = this.country_id;
        data["country_name"] = this.country_name;
        if (Array.isArray(this.state)) {
            data["state"] = [];
            for (let item of this.state)
                data["state"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICountryWithStateAndCityOutputData {
    /** The auto-generated id of the country master */
    country_id: number;
    /** The country name with 255 character limit */
    country_name: string;
    state: CountryWithStateAndCityOutputStateData[];
}

